import { Column } from "Components/Common/CommonTableIndexWise";
import { NavigateFunction } from "react-router-dom";

export const studyColumn = (navigate: NavigateFunction, volunteerId: string | number): Column[] => [
  {
    key: "studycode",
    label: "Study Code",
    type: "link",
    onClick: (row) => {
      localStorage.setItem("activestudyid", row.studyid);
      localStorage.setItem("studycode", row.studycode);
      navigate(`/volunteer/details/${volunteerId}/study/dashboard/${row.studyid}`);
    },
  },
  {
    key: "studytitle",
    label: "Study Title",
  },
  { key: "sponsorname", label: "Sponsor" },
  { key: "studydesigntext", label: "Design" },
  { key: "totalsubjects", label: "Subjects" },
  { key: "numberofperiods", label: "Periods" }
];